import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// import { useLayers } from '../../context/LayerContext'; // Commented: unused import
// import { useContainers } from '../../context/ContainerContext'; // Commented: unused import
// import { useGames } from '../../context/GameContext'; // Commented: unused import
// import { useHistory } from '../../context/HistoryContext'; // Commented: unused import
import { useAuth } from '../../context/AuthContext';
import { safeNavigate } from '../../utils/navigationUtils';
// import GameStateManager from '../../services/GameStateManager'; // Commented: unused import
import './LoadGameModal.css';

const LoadGameModal = ({ isOpen, onClose, onLoadSuccess, tokens, setTokens, selectedTokenIds, setSelectedTokenIds, tokenGroups, setTokenGroups }) => {
  const [savedGames, setSavedGames] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingGame] = useState(false); // setIsLoadingGame removed: unused setter
  const [loadProgress] = useState(0); // setLoadProgress removed: unused setter
  const [loadStatus] = useState(''); // setLoadStatus removed: unused setter
  const [error, setError] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('updatedAt'); // updatedAt, name, size
  const [selectedGame] = useState(null); // setSelectedGame removed: unused setter
  // Add confirmation dialog state
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [gameToDelete, setGameToDelete] = useState(null);

  const navigate = useNavigate();
  // const layerContext = useLayers(); // Commented: unused context
  // const containerContext = useContainers(); // Commented: unused context
  // const gameContext = useGames(); // Commented: unused context
  // const historyContext = useHistory(); // Commented: unused context
  const authContext = useAuth();

  // טעינת רשימת המשחקים השמורים
  useEffect(() => {
    if (isOpen && authContext.currentUser) {
      loadSavedGames();
    }
  }, [isOpen, authContext.currentUser]);

  const loadSavedGames = async () => {
    setIsLoading(true);
    setError('');

    try {
      const response = await fetch('/api/game-states', {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (!response.ok) {
        throw new Error(`Server error: ${response.statusText}`);
      }

      const games = await response.json();
      setSavedGames(games);

    } catch (error) {
      console.error('Error loading saved games:', error);
      setError(`Error loading saved games: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  // סינון וסידור המשחקים
  const filteredAndSortedGames = React.useMemo(() => {
    let filtered = savedGames;

    // סינון לפי חיפוש
    if (searchTerm) {
      filtered = filtered.filter(game => 
        game.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (game.description && game.description.toLowerCase().includes(searchTerm.toLowerCase()))
      );
    }

    // סידור
    filtered.sort((a, b) => {
      switch (sortBy) {
        case 'name':
          return a.name.localeCompare(b.name);
        case 'size':
          return (b.metadata?.estimatedSize || 0) - (a.metadata?.estimatedSize || 0);
        case 'updatedAt':
        default:
          return new Date(b.updated_at) - new Date(a.updated_at);
      }
    });

    return filtered;
  }, [savedGames, searchTerm, sortBy]);

  // טעינת משחק
  const handleLoadGame = async (game) => {
    try {
      setIsLoading(true);
      setError(null);

      // Just navigate to the app with the gameId - let MapEditorContent handle the loading
      safeNavigate(navigate, `/app?gameId=${game.game_state_id}`);
      onClose();
      
      // Call onLoadSuccess with game info if callback is provided
      if (onLoadSuccess) {
        onLoadSuccess({
          gameStateId: game.game_state_id,
          gameId: game.game_state_id,
          name: game.name,
          metadata: game.metadata
        });
      }
      
    } catch (error) {
      console.error('[LoadGameModal] Error loading game:', error);
      setError(error.message || 'Failed to load game');
    } finally {
      setIsLoading(false);
    }
  };

  // מחיקת משחק
  const handleDeleteGame = async (game, event) => {
    event.stopPropagation(); // מניעת טעינת המשחק
    
    // Show custom confirmation dialog
    setGameToDelete(game);
    setShowDeleteConfirm(true);
  };

  const handleConfirmDeleteGame = async () => {
    if (!gameToDelete) return;

    try {
      const response = await fetch(`/api/game-states/${gameToDelete.game_state_id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (!response.ok) {
        throw new Error(`Server error: ${response.statusText}`);
      }

      // הסרה מהרשימה המקומית
      setSavedGames(prev => prev.filter(g => g.game_state_id !== gameToDelete.game_state_id));

    } catch (error) {
      console.error('Error deleting game:', error);
      setError(`Error deleting game: ${error.message}`);
    } finally {
      // Close dialog
      setShowDeleteConfirm(false);
      setGameToDelete(null);
    }
  };

  const handleCancelDeleteGame = () => {
    setShowDeleteConfirm(false);
    setGameToDelete(null);
  };

  // פורמט תאריך
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('he-IL', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // פורמט גודל קובץ
  const formatFileSize = (bytes) => {
    if (!bytes) return 'Unknown';
    
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  };

  if (!isOpen) return null;

  return (
    <div className="load-game-modal-overlay">
      <div className="load-game-modal">
        <div className="modal-header">
          <h2>📁 Load Game</h2>
          {!isLoadingGame && (
            <button className="close-btn" onClick={onClose}>×</button>
          )}
        </div>

        <div className="modal-content">
          {!isLoadingGame ? (
            <>
              {/* כלי חיפוש וסינון */}
              <div className="search-controls">
                <div className="search-box">
                  <input
                    type="text"
                    placeholder="Search games..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="search-input"
                  />
                  <span className="search-icon">🔍</span>
                </div>
                
                <select 
                  value={sortBy} 
                  onChange={(e) => setSortBy(e.target.value)}
                  className="sort-select"
                >
                  <option value="updatedAt">Sort by Date</option>
                  <option value="name">Sort by Name</option>
                  <option value="size">Sort by Size</option>
                </select>
              </div>

              {/* רשימת משחקים */}
              <div className="games-list">
                {isLoading ? (
                  <div className="loading-state">
                    <div className="loading-spinner"></div>
                    <p>Loading saved games...</p>
                  </div>
                ) : filteredAndSortedGames.length === 0 ? (
                  <div className="empty-state">
                    {searchTerm ? (
                      <>
                        <span className="empty-icon">🔍</span>
                        <h3>No games found</h3>
                        <p>No games found matching search "{searchTerm}"</p>
                      </>
                    ) : (
                      <>
                        <span className="empty-icon">📁</span>
                        <h3>No saved games</h3>
                        <p>You haven't saved any games yet. Start creating and saving games!</p>
                      </>
                    )}
                  </div>
                ) : (
                  filteredAndSortedGames.map(game => (
                    <div 
                      key={game.game_state_id} 
                      className="game-item"
                      onClick={() => handleLoadGame(game)}
                    >
                      <div className="game-thumbnail">
                        <div 
                          className="thumbnail-placeholder"
                          style={game.thumbnail_url && game.thumbnail_url.includes('http') ? { backgroundImage: `url(${game.thumbnail_url})` } : {}}
                        >
                          {(!game.thumbnail_url || !game.thumbnail_url.includes('http')) && (
                            <svg className="placeholder-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                              <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                              <circle cx="8.5" cy="8.5" r="1.5"/>
                              <polyline points="21,15 16,10 5,21"/>
                            </svg>
                          )}
                        </div>
                      </div>
                      
                      <div className="game-info">
                        <h3 className="game-name">{game.name}</h3>
                        {game.description && (
                          <p className="game-description">{game.description}</p>
                        )}
                        
                        <div className="game-meta">
                          <span className="meta-item">
                            📅 {formatDate(game.updated_at)}
                          </span>
                          <span className="meta-item">
                            📊 {formatFileSize(game.metadata?.estimatedSize)}
                          </span>
                          {game.metadata?.layerCount !== undefined && (
                            <span className="meta-item">
                              🗂️ {game.metadata.layerCount} layers
                            </span>
                          )}
                          {game.metadata?.tokenCount !== undefined && (
                            <span className="meta-item">
                              🎭 {game.metadata.tokenCount} tokens
                            </span>
                          )}
                          {game.is_public && (
                            <span className="meta-item public-badge">
                              🌐 Public
                            </span>
                          )}
                        </div>
                      </div>
                      
                      <div className="game-actions">
                        <button 
                          className="delete-btn"
                          onClick={(e) => handleDeleteGame(game, e)}
                          title="Delete game"
                        >
                          🗑️
                        </button>
                      </div>
                    </div>
                  ))
                )}
              </div>

              {/* הודעת שגיאה */}
              {error && (
                <div className="error-message">
                  <span className="error-icon">⚠️</span>
                  {error}
                </div>
              )}
            </>
          ) : (
            /* מסך התקדמות טעינה */
            <div className="load-progress">
              <div className="progress-header">
                <h3>Loading Game...</h3>
                {selectedGame && (
                  <p>Loading "{selectedGame.name}"</p>
                )}
                <p>{loadStatus}</p>
              </div>
              
              <div className="progress-bar">
                <div 
                  className="progress-fill" 
                  style={{ width: `${loadProgress}%` }}
                ></div>
              </div>
              
              <div className="progress-text">
                {loadProgress}%
              </div>

              {loadProgress === 100 && (
                <div className="success-message">
                  <span className="success-icon">✅</span>
                  Game loaded successfully!
                </div>
              )}
            </div>
          )}
        </div>

        {/* כפתורי פעולה */}
        {!isLoadingGame && (
          <div className="modal-actions">
            <button 
              className="btn btn-secondary" 
              onClick={onClose}
            >
              Close
            </button>
            <button 
              className="btn btn-primary" 
              onClick={loadSavedGames}
              disabled={isLoading}
            >
              🔄 Refresh List
            </button>
          </div>
        )}

        {/* Delete Confirmation Dialog */}
        {showDeleteConfirm && (
          <div className="confirmation-overlay">
            <div className="confirmation-dialog">
              <div className="confirmation-header">
                <h3>Delete Game</h3>
                <button 
                  className="close-btn"
                  onClick={handleCancelDeleteGame}
                >
                  ×
                </button>
              </div>
              <div className="confirmation-body">
                <p>Are you sure you want to delete the game "{gameToDelete?.name}"?</p>
                <p className="warning-text">
                  <i className="fas fa-exclamation-triangle"></i>
                  This action cannot be undone.
                </p>
              </div>
              <div className="confirmation-actions">
                <button 
                  className="confirm-btn cancel-btn"
                  onClick={handleCancelDeleteGame}
                >
                  Cancel
                </button>
                <button 
                  className="confirm-btn delete-btn"
                  onClick={handleConfirmDeleteGame}
                >
                  Delete Game
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LoadGameModal; 